module.exports = __webpack_public_path__ + "static/media/warning-icon.62d23dd4.svg";